import { Alert } from 'src/design/atoms/Alert';
import { IconAlertCircle } from '@tabler/icons-react';
import React, { useMemo } from 'react';
import { getErrorMessage } from 'src/utils';
import { Header } from 'src/design/organisms/Header';
import { WorkflowStatusPanel } from 'src/design/molecules/WorkflowStatusPanel';
import { useWorkflowStatusFilters } from 'src/app/workflows/useWorkflowStatusFilters';
import { useWorkflowStatusSegments } from 'src/app/workflows/useWorkflowStatusSegments';
import { mergeWorkflowSteps } from 'src/app/workflows/mergeWorkflowSteps';
import { useChangesOverview } from 'src/api/queries/changes/useChangesOverview';
import { ChangesOverviewTable } from './components/ChangesOverviewTable';

export const Changes: React.FC = () => {
  const { data, isLoading, error } = useChangesOverview();
  const changes = useMemo(() => data ?? [], [data]);

  const mergedWorkflow = useMemo(() => mergeWorkflowSteps(changes), [changes]);

  const { filters, covered, statusFilter, setStatusFilter, filteredItems } =
    useWorkflowStatusFilters(changes, mergedWorkflow);
  const segments = useWorkflowStatusSegments(
    changes,
    filters,
    covered,
    mergedWorkflow,
  );

  return (
    <>
      <Header
        title="Changes"
        breadcrumbProps={{ items: [{ text: 'Changes' }] }}
        helpText="View change orders across all jobs you have access to. Select a change to open it in its job."
      />

      {error && (
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="Error"
          color="red"
          mb="md"
        >
          {getErrorMessage(error)}
        </Alert>
      )}

      <WorkflowStatusPanel
        segments={segments}
        value={statusFilter}
        onChange={setStatusFilter}
      />

      <ChangesOverviewTable changes={filteredItems} loading={isLoading} />
    </>
  );
};
